import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { Cliente } from './Cliente';
import { Vertical } from '../Verticales/Vertical';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IClienteEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: Cliente | undefined;
}

export interface IClienteEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    verticales: any[];
    openErroDialog: boolean;
}

export default class ClienteEdit extends React.Component<IClienteEditProps, IClienteEditState> {
    _cliente: Cliente = new Cliente();
    _id: number = -1;
    
    public constructor(props: IClienteEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            verticales: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetVerticales();
    }

    componentWillReceiveProps(nextProps: Readonly<IClienteEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._cliente = nextProps.selectedItem;

            if(this._cliente.defaultFallow!.toString().indexOf === undefined) {
                this._cliente.defaultFallow = 0;
            }
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar cliente
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth variant="standard" style={{marginBottom: '20px'}}>
                                <InputLabel id="labelVerticales">Vertical</InputLabel>
                                <Select label="Vertical" labelId='labelVerticales' defaultValue={this._cliente.verticalId?.toString()} onChange={(event: SelectChangeEvent) => {
                                    this._cliente.verticalId = Number(event.target.value);
                                }}>
                                    {
                                        this.state.verticales.map((value: Vertical, index: number) => {
                                            return (
                                                <MenuItem value={value.id} key={index}>
                                                    {
                                                        value.name
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' defaultValue={this._cliente.razonSocial} label='Razón social' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._cliente.razonSocial = event.target.value;
                                    }
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.cif} label='CIF' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.cif = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.direccion} label='Dirección' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.direccion = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.codigoPostal} label='Código postal' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.codigoPostal = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.localidad} label='Localidad' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.localidad = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.provincia} label='Provincia' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.provincia = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' defaultValue={this._cliente.pais} label='País' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.pais = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField type='number' variant='standard' defaultValue={this._cliente.defaultFallow} label='Barbecho por defecto' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.defaultFallow = Number(event.target.value);
                                }}/>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._cliente.razonSocial == '' || this._cliente.razonSocial == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/clientes/${this._cliente.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._cliente),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._cliente = new Cliente();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._cliente = new Cliente();
        });
    }

    private GetVerticales() {
        let url = `${Common.END_POINT}/masters/Verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    verticales: response
                }
            );
        })
    }
}